export const QUICK_BOOK_ACTION_TYPE = 'open_quick_book';

export const QUICK_BOOK_MODES = [
    { value: 'FIXED_SERVICE', label: 'Fixed-price service' },
    { value: 'INSPECTION_FIRST', label: 'Inspection-first service' }
];

export const QUICK_BOOK_SERVICE_ID_PATTERN = /^qbs_[a-zA-Z0-9_-]+$/;

export const isValidQuickBookServiceId = (serviceId) => (
    typeof serviceId === 'string'
    && serviceId.length <= 64
    && QUICK_BOOK_SERVICE_ID_PATTERN.test(serviceId)
);

export const buildSectionItemActionData = (actionType, actionData = {}) => {
    if (actionType === 'open_service') {
        return { route: '/tagServicesScreen' };
    }
    if (actionType === 'navigate') {
        return { route: actionData?.route || '' };
    }
    if (actionType === 'open_url') {
        return { url: actionData?.url || '' };
    }
    if (actionType === QUICK_BOOK_ACTION_TYPE) {
        return {
            mode: actionData?.mode || '',
            ...(actionData?.quickBookServiceId
                ? { quickBookServiceId: actionData.quickBookServiceId }
                : {})
        };
    }
    return null;
};

export const quickBookModeLabel = (mode) => (
    QUICK_BOOK_MODES.find((option) => option.value === mode)?.label || mode || 'N/A'
);
